import axios from "axios";

export const setTenantId = (tenantId) => {
    if (tenantId) {
        axios.defaults.headers.common["tenantId"] = tenantId;
    } else {
        delete axios.defaults.headers.common["tenantId"];
    }
};